module.exports = __webpack_public_path__ + "img/ic_order_confirmed_circle_filled.bd6dbc9a.png";